import { render, staticRenderFns } from "./text-row-balance.vue?vue&type=template&id=d572ce5e&scoped=true&"
import script from "./text-row-balance.vue?vue&type=script&lang=js&"
export * from "./text-row-balance.vue?vue&type=script&lang=js&"
import style0 from "./text-row-balance.vue?vue&type=style&index=0&id=d572ce5e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d572ce5e",
  null
  
)

export default component.exports